import React from 'react';

function StopsSearch({ searchTerm, setSearchTerm }) {
  return (
    <div className="search-container">
      <input
        type="search"
        placeholder="Wyszukaj przystanek..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
        aria-label="Wyszukaj przystanek"
        autoComplete="off"
        id="stop-search"
      />
    </div>
  );
}

export default StopsSearch;